import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-color1",
  "use": "icon-color1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-color1\">\n<rect width=\"24\" height=\"24\" rx=\"2\" fill=\"white\" />\n<path d=\"M10.822 7.004L7 17H8.75L9.66 14.494H13.846L14.756 17H16.506L12.684 7.004H10.822ZM10.15 13.15L11.732 8.768H11.788L13.356 13.15H10.15Z\" fill=\"#E08245\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol